<div class="dashboard heisenberg-background">
  <div class='content'>
    <h1>Magalies Pharma Prescriptions</h1>
    @if (!currentUser) {
      <a  routerLink="/portal" mat-raised-button color='primary'>
        <mat-icon>lock_open</mat-icon> Sign In
      </a>
    }
    @if (currentUser) {
      <a routerLink="/portal/submit" mat-raised-button color="primary">
        <mat-icon>add</mat-icon> New prescription
      </a>
    }
  </div>
</div>